import { render } from "./OpenQRCode.vue?vue&type=template&id=a553cab0&scoped=true&ts=true"
import script from "./OpenQRCode.vue?vue&type=script&lang=ts"
export * from "./OpenQRCode.vue?vue&type=script&lang=ts"

import "./OpenQRCode.vue?vue&type=style&index=0&id=a553cab0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a553cab0"]])

export default __exports__